import $ from 'jquery';

export default class ThemeUtils {
  static extend(dest, ...objs) {
    for (const obj in objs) {
      for (const k in objs[obj]) {
        const v = objs[obj][k];
        dest[k] = v;
      }
    }

    return dest;
  }

  static windowWidth() {
    const documentWidth = document.documentElement.clientWidth;
    const windowWidth = window.innerWidth;

    const width = documentWidth < windowWidth ? windowWidth : documentWidth;

    return width;
  }

  static debounce(func, wait, immediate) {
    let timeout = null;
    return () => {
      const context = this;
      const args = arguments;

      const later = () => {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  static inViewport(el) {
    // special bonus for those using jQuery
    let element = el;
    let viewportHeight;
    let viewportWidth;

    if ((typeof jQuery === 'function') && el instanceof jQuery) {
      element = el.eq(0);
    }

    const rect = element.getBoundingClientRect();

    if (document.documentElement.clientWidth < window.innerWidth) {
      viewportWidth = document.documentElement.clientWidth;
    } else {
      viewportWidth = window.innerHeight;
    }

    if (document.documentElement.clientHeight < window.innerHeight) {
      viewportHeight = document.documentElement.clientHeight;
    } else {
      viewportHeight = window.innerHeight;
    }

    return (rect.bottom >= 0)
      && (rect.right >= 0)
      && (rect.top <= viewportHeight)
      && (rect.left <= viewportWidth);
  }

  static externalLinks($el) {
    const anchors = $el.find('a[href^="http"]').filter((i, el) => el.href.indexOf(window.location.hostname) === -1);

    anchors.attr('target', '_blank');
  }

  static unique(array) {
    let key;
    let asc; let
      end;
    const output = {};
    for (key = 0, end = array.length, asc = end >= 0; asc ? key < end : key > end; asc ? key++ : key--) { output[array[key]] = array[key]; }
    return (() => {
      const result = [];
      for (key in output) {
        const value = output[key];
        result.push(value);
      }
      return result;
    })();
  }

  static scrollTarget($el) {
    let $element = $el;

    if (!($el instanceof jQuery)) {
      $element = $($el);
    }

    $('html, body').animate({
      scrollTop: $element.offset().top,
    }, 500, 'linear');
  }
}
